var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"earchresults_noresultsarea mb-5"},[_c('div',{staticClass:"noresultsarea_box"},[_c('img',{attrs:{"src":"/assets/sabre-img/noresults.png","alt":"noresults"}})])])
}]

export { render, staticRenderFns }